<template>
  <router-view />
</template>

<script setup lang="ts">
// import HelloWorld from './components/HelloWorld.vue'
</script>

<style lang="scss">
@use "@/css/common.scss";
@use "@/css/common-text.scss";
@use "@/css/common-radius.scss";
@use "@/css/common-box.scss";
@use "@/css/common-color.scss";
@use "@/css/main.scss";
@use "@/css/use-animation.scss";
</style>
